import useSWR from "swr";

import { getSWRKey, SwrStore } from "~utils";

import { PartialPreferences } from "./preferences";
import { PreferencesNotFoundError } from "./preferences-not-found-error";
import { usePreferencesLocalPersistence } from "./use-preferences-local-persistence";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function usePreferencesLocalSwr() {
  const { getPreferences } = usePreferencesLocalPersistence();

  const fetchPreferences = (): Promise<PartialPreferences | null> =>
    getPreferences().catch((error) => {
      if (error instanceof PreferencesNotFoundError) return null;
      throw error;
    });

  return useSWR(getSWRKey(SwrStore.LocalPreferences), fetchPreferences, {
    suspense: true,
  });
}
